import React from 'react';
import PropTypes from 'prop-types';

import './CloseButtonComponent.scss';

class CloseButtonComponent extends React.Component {
    render() {
        return (
            <button className="bt-close" onClick={this.props.onClick}>
                x
            </button>
        );
    }
}

CloseButtonComponent.propTypes = {
    onClick: PropTypes.func.isRequired
};

export default CloseButtonComponent;



// WEBPACK FOOTER //
// ./src/components/button/CloseButtonComponent.js